import React, { ReactNode } from "react";
import { Modal } from "react-bootstrap";
import "./modalPrintable.scss";

interface IProps {
  show: boolean;
  handleClose: () => void;
  children: ReactNode;
  headerText: string;
  printbutton?: boolean;
  modalsize: "sm" | "lg" | "xl" | undefined;
}
const ModalPrintable: React.FC<IProps> = ({
  show,
  handleClose,
  headerText,
  children,
  printbutton = true,
  modalsize,
}) => {
  const isIFrame = (input: HTMLElement | null): input is HTMLIFrameElement =>
    input !== null && input.tagName === "IFRAME";

  const print = () => {
    const content = document.getElementById("divcontents");
    const pri = document.getElementById("ifmcontentstoprint");
    if (isIFrame(pri) && pri.contentWindow) {
      const doc = pri.contentWindow;
      doc.document.open();
      
      
  
      if (content) {
        // Cloner le contenu pour supprimer les boutons
        const clonedContent = content.cloneNode(true) as HTMLElement;
        
        // Supprimer tous les boutons du clone
        const buttons = clonedContent.querySelectorAll('button, .btn, [role="button"], .no-print');
        buttons.forEach(btn => btn.remove());
        
        // Supprimer les contraintes de hauteur et scroll de TOUS les éléments
        const allElements = clonedContent.querySelectorAll('*');
        allElements.forEach(element => {
          if (element instanceof HTMLElement) {
            element.style.maxHeight = 'none';
            element.style.height = 'auto';
            element.style.overflow = 'visible';
          }
        });
        
        // Traiter aussi le clonedContent lui-même
        clonedContent.style.maxHeight = 'none';
        clonedContent.style.height = 'auto';
        clonedContent.style.overflow = 'visible';
        
        doc.document.write(clonedContent.innerHTML);
      }
      doc.document.write('</body></html>');
      doc.document.close();
      
      // Attendre le chargement avant d'imprimer
      setTimeout(() => {
        doc.focus();
        doc.print();
      }, 250);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size={modalsize}>
      <Modal.Header closeButton>
        <div className="fw-bold">
          <h5
            className="inject-wysiwyg"
            dangerouslySetInnerHTML={{ __html: headerText }}
          />
          {printbutton && (
            <button
              onClick={print}
              className="btn-secondary position-absolute modal-print"
            >
              <i className="bi-printer pe-2" />
              Imprimer
            </button>
          )}
        </div>
      </Modal.Header>
      <Modal.Body style={{textAlign:"left"}}>
        <>
          <iframe
            id="ifmcontentstoprint"
            style={{ height: "0px", width: "0px", position: "absolute" }}
          />
          <div id="divcontents">{children}</div>
        </>
      </Modal.Body>
    </Modal>
  );
};

export default ModalPrintable;
